export const about = {
  main: {
    paragraphs: [
      'Simon Adél vagyok, stílustanácsadó, és hiszem, hogy a belső és külső harmónia egymást erősítik, és hogy a megjelenésünkkel való törődés nem úri huncutság. Az önazonos, harmonikus öltözködés és a természetes szépség elérhető! Ezt szeretném megmutatni nektek.',
      '2021-ben végeztem el Huszka Ági színtanácsadó képzését, azóta többszázatok színtípusát segítettem megtalálni. Szintén Áginál tanultam testalkatelemzést, az ott megszerzett tudást mélyítettem tovább Gózon Eszter (The less waste stylist) testalkatelemző képzésén 2023 elején.',
      '2024 óta rendszeres társoktatóként veszek részt Huszka Ági Stílustanácsadó képzésén.'
    ]
  }
}
